import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import type { BlindOffMessage } from '@module/types/centrifuge/public-message/blindMessageTypes';
interface Props {
  fontSizeClass?: string;
  item: BlindOffMessage;
}
export default function BlindOffChat(props) {
  const $ = _c(7);
  const {
    fontSizeClass,
    item
  } = props;
  const {
    message
  } = item.data;
  let t0;
  if ($[0] !== fontSizeClass) {
    t0 = cn("mb-[3px] whitespace-pre-wrap text-cht_al_2", fontSizeClass);
    $[0] = fontSizeClass;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = `${message.name}에 의해 ${message.type}블라인드가 해제되었습니다.`;
  let t2;
  if ($[2] !== t1) {
    t2 = <div>{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0 || $[5] !== t2) {
    t3 = <div className={t0}>{t2}</div>;
    $[4] = t0;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}